<template>
  <footer :class="(dataPage.route == 'accueil' || dataPage.route == 'contact' ? 'mt-0' : '')">
    <div class="container" >
        <div class="row">

            <div class="col-md-6 col-lg-3 col-12">
                <img src="@/../public/elements/logo-princ.png" alt="">
            </div>


            <div class="col-md-6 col-12 contact-footer  d-flex d-lg-none flex-column justify-content-end align-items-left">
                <p class="font-25px c-bleu text-md-left">
                    <span class="font-15px">(à proximité de la Place Saint Paul de Rouen)</span><br>
                    270A Route de Paris<br>76920 Amfreville-la-Mi-Voie
                </p>
                <a class="font-20px c-v text-decoration-none">contact@veroniquelesourd.fr</a>
                <a class="font-30px c-v text-decoration-none">06 50 73 61 18</a>
            </div>

            <div class="col-lg-5 col-12 d-flex flex-row justify-content-space align-items-start">
                <ul>
                    <li><router-link tag="a" to="/prestation-magnetisme" class="c-bleu text-decoration-none font-25px">Magnétisme</router-link></li>
                    <li><router-link tag="a" to="/prestation-hypnose" class="c-bleu text-decoration-none font-25px">Hypnose</router-link></li>
                    <li><router-link tag="a" to="/prestation-coaching-et-pnl" class="c-bleu text-decoration-none font-25px">Coaching et PNL</router-link></li>
                    <li><router-link tag="a" to="/prestation-hypno-coaching-en-entreprise" class="c-bleu text-decoration-none font-25px">Coaching en entreprise</router-link></li>
                </ul>
                <ul>
                    <li><router-link tag="a" to="/seance" class="c-bleu text-decoration-none font-25px">Séances & Tarifs</router-link></li>
                    <li><router-link tag="a" to="/contact" class="c-bleu text-decoration-none font-25px">Actualités</router-link></li>
                    <li><router-link tag="a" to="/contat" class="c-bleu text-decoration-none font-25px">Contact & RDV</router-link></li>
                </ul>
            </div>

            <div class="col-lg-4 d-none d-lg-flex contact-footer d-flex flex-column justify-content-end align-items-left">
                <p class="font-25px c-bleu">
                    <span class="font-15px">(à proximité de la Place Saint Paul de Rouen)</span><br>
                    270A Route de Paris<br>76920 Amfreville-la-Mi-Voie
                </p>
                <a class="font-20px c-v text-decoration-none">contact@veroniquelesourd.fr</a>
                <a class="font-30px c-v text-decoration-none">06 50 73 61 18</a>
            </div>
        </div>
    </div>

    <div class="container copy">
        <div class="d-flex flex-lg-row flex-column justify-content-center align-self-center">
            <p>Copyright © 2020 - <span class="c-bleu">VERONIQUE LESOURD</span>  - Tous droits réservés.</p>
            <p>Conception et réalisation : <a href="https://www.devinfluence.fr" class="copy text-decoration-none">DEV'INFLUENCE</a> - <a href="mentions-legales" class="copy text-decoration-none">Mentions Légales</a></p>
        </div>
    </div>
  </footer>
  <!--<div id="footer" class="bg-2">
    <div id="infos-footer" class="bg-bf d-flex flex-column justify-content-end">
      <div
        class="bold info-menu-footer bg-bc py-2 pt-4 d-flex flex-row justify-content-start"
      >
        <img src="@/../public/elements/pin.png" alt="map" />
        <a href="#" class="c-g pl-3"
          >362 rue de la République<br />76230 Bois-Guillaume</a
        >
      </div>
      <div
        class="info-menu-footer bg-bc pt-3 pb-2 pb-5 d-flex flex-row justify-content-start"
      >
        <img src="@/../public/elements/icone-clock.png" alt="horaires" />
        <a href="#" class="c-g pl-3"
          >Lundi au Vendredi 9h > 19h<br />Samedi 9h > 12h30</a
        >
      </div>
      <div class="bas bg-w">
        <img src="@/../public/elements/logo-cbgr-full.png" alt="logo" />
      </div>
    </div>
    <div class="bleu bg-bc">
      <div class="docteurs">
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Clémentine DECRETTE</b></p>
          <p><a href="tel:0235025583" class="phone">02 35 02 55 83</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-clementine-decrette">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Thibault GANCEL</b></p>
          <p><a href="tel:0235590412" class="phone">02 35 59 04 12</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-thibault-gancel">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Antoine GODDEFROY</b></p>
          <p><a href="tel:0235712185" class="phone">02 35 71 21 85</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-antoine-goddefroy">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Edouard SOUBRANE</b></p>
          <p><a href="tel:0235345102" class="phone">02 35 34 51 02</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-edouard-soubrane">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Marie DELAUME</b></p>
          <p><a href="tel:0235712185" class="phone">02 35 71 21 85</a></p>
          <p>&gt;&gt; <router-link tag="a" to="docteur-marie-delaume">voir la fiche</router-link> &lt;&lt;</p>
        </div>
        <div class="infos col-6 col-lg-4 c-w">
          <p><b>Dr Claire NICOLAS</b></p>
          <p><a href="tel:0235590412" class="phone">02 35 59 04 12</a></p>
          <p>&gt;&gt;&gt;<router-link tag="a" to="docteur-claire-nicolas">voir la fiche</router-link>&lt;&lt;&lt;</p>
        </div>
      </div>
    </div>
    <div class="blanc bg-w">
      <p class="c-bc">
        Copyright © 2020 <a href="#">CBGR</a> - Tous droits réservés. Conception
        et Réalisation : <a href="https://www.devinfluence.fr" target="new">DEV'INFLUENCE</a> -
        <router-link tag="a" to="mentions-legales">Mentions Légales</router-link>
      </p>
    </div>
  </div>-->
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

export default {
  name: "esp-header",
  props: {
    dataPage: {
      type: Object,
    },
    dataIris: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    color1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    color2: function () {
      if (this.dataIris.customizableVar[1].value) {
        return this.dataIris.customizableVar[1].value;
      } else {
        return "0f555d";
      }
    },
    customizableVar1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
  },
  methods: {
    formatLabelMenu(str) {
      return str.replace("<br>", " ");
    },
    getSrcMenuPage(idPage) {
      let page = this.$parent.dataIris.pages.find((page) => page.id === idPage);

      return ""; //require('@/html/elements/o-'+page.customizableVar[0].value.value+'.svg')
    },
  },
};
</script>

